import React, { useEffect, useRef, useState } from 'react';
import {
	collection,
	doc,
	getDoc,
	getDocs,
	query,
	where,
	updateDoc,
	increment,
	setDoc,
	orderBy,
} from 'firebase/firestore';
import { modalService } from '../../../services/modal.service';
import { UserCampaignModal } from '../../../pages/HomePage/HomePageModal/UserCampaignModal';
import { db } from '../../../services/analyticsAndLogs.service';
import { useSelector } from 'react-redux';
import { getUserData } from '../../../store/selectors/login.selectors';
import { Role } from '../../../constants/roleTypes.constant';
import { getAuth } from 'firebase/auth';


export const InAppMessages = ( { userRole }: {userRole: Role} ) => {
	const userData = useSelector(getUserData);
	const [messageId, setMessageId] = useState(""); 
	const [campaignPages, setCampaignPages] = useState<any>();
	const [messagesData, setMessagesData] = useState<any[]>();
	const [enableUserDismissal, setEnableUserDismissal] = useState();
	const campaignIndex = useRef<number>(0);
	useEffect(() => {
		getAuth().authStateReady().then(getCampaignData);
		// initializeInsertData();
	}, []);

	useEffect(() => {
		if (campaignPages?.length > 0) {
			onWorkerCampaign();
			updateUserActivityData(messageId);
		}
	}, [campaignPages]);

	useEffect(() => {
		setShowMessageData();
	}, [messagesData]);

	const setShowMessageData = async () => {
		if (!messagesData || messagesData.length === 0) {
			return;
		}

		const currentCampaign = messagesData[campaignIndex.current];

		// recursively break
		if (!currentCampaign) {
			return;
		}

		const pagesData = await getPages(currentCampaign?.contentPagesList);
		const userActivityData = await getUserActivityData(currentCampaign.id);

		const userDismissed = userActivityData ? userActivityData.userDismissed : false;
		const userCountFinish = userActivityData ? currentCampaign.enableExposuresLimit && 
			userActivityData.count >= currentCampaign.numberOfExposures : false;
		const displayCampaign = !userDismissed && !userCountFinish;

		if (displayCampaign) {
			setMessageId(currentCampaign.id);
			setEnableUserDismissal(currentCampaign.enableUserDismissal);
			setCampaignPages(pagesData);
		} else {
			campaignIndex.current += 1;
			await setShowMessageData();
		}
	};

	const getCampaignData = async () => {
		/**
		 * Get all active campaigns
		 * Active campaign = campaign with state true, endAt date (default value 2035) in the future and startAt date in the past (default value 1 day before the current date)
		 * Then filter the campaigns according to the user role (employee, employer, representative) and if the campaign should be already displayed according to the startAt date
		 * The campaign will be displayed if the user didn't dismissed it or didn't reach the number of exposures limit (if exist)
		 */
		const now = new Date();
		const todayStart = new Date(now.setHours(0, 0, 0, 0));
		const inAppCol = collection(db, 'InAppMessages');
		const q = query(inAppCol, where('state', '==', true), where('targetUser', 'array-contains', userRole) , where("endAt", ">=" , todayStart), orderBy('endAt'));
		try {
			const docs = await getDocs(q);
	
			if (docs.empty) {
				console.log('No matching documents.');
				return;
			}		

			const activeMessages = docs.docs.map(m => ({...m.data(), id: m.id}))
				.filter(campaign => {
					const startAt = campaign.startAt?.toDate ? campaign.startAt.toDate() : null;
					return !startAt || startAt.setHours(0,0,0,0) <= todayStart.getTime(); 
				}
			);		
			setMessagesData(activeMessages);
		} catch (err) {
			console.log('Firestore Error getting documents: ', err);
		}
	};

	const getPages = async (docs: any) => {
		const docRefIds = docs.map((d: any) => d.id.toString());
		const contentPagesCol = collection(db, 'content_pages');
		const docsSnapshot = await getDocs(contentPagesCol);
		let pagesDataDocs = docsSnapshot.docs;
		return docRefIds.map((docId: string) => pagesDataDocs.find(d => d.data().id === docId)).filter(Boolean);
	};

	// update user count when show popup
	const updateUserActivityData = async (messageId: string) => {
		try {
			const docRef = doc(db, 'InAppMessages', messageId, 'UserActivity', userData.user_id.toString());
			await setDoc(docRef, {
				count: increment(1)
			}, { merge: true });
		} catch (err) {
			console.log('failed updating user activity', err);
		}
	};

	const getUserActivityData = async (messageId: any) => {
		const docRef = doc(db, 'InAppMessages', messageId, 'UserActivity', userData.user_id.toString());
		const docSnap = await getDoc(docRef);
		return docSnap.exists() ? docSnap.data() as { userDismissed: boolean; count: number } : null;
	};

	const updateUserDismissed = async (isChecked: boolean) => {
		try {
			const docRef = doc(db, 'InAppMessages', messageId, 'UserActivity', userData.user_id.toString());
			await setDoc(docRef, {
				userDismissed: isChecked
			}, { merge: true });
		} catch (err) {
			console.log('failed updating user dismissed', err);
		}
	};

	const onWorkerCampaign = async () => {
		await modalService.openModal(null, { hideCloseBtn:true }, (props: any) => (
			<UserCampaignModal
				campaignPages={campaignPages}
				openWithButton={false}
				enableUserDismissal={enableUserDismissal}
				onResponse={(check)=>updateUserDismissed(check)}
				{...props}
			/>
		));
		campaignIndex.current += 1;
		await setShowMessageData();
	};

	return <></>;
};
